// Globals
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuProps } from 'antd';

// Components
import { StyledPageWrapper } from '../../components/Styled';
import { StyledHeaderWrapper, StyledMenu, StyledPageTitle } from './SeoMainContainerStyles';

// Helpers
import { SeoTabs, getSeoTabsConfig } from '../../helpers';

const SeoMainContainer = () => {
  const { t } = useTranslation(['seo']);
  const seoTabsConfig = useMemo(() => getSeoTabsConfig(t), []);
  const [selectedKey, setSelectedKey] = useState(seoTabsConfig[0].key);

  const selectedSeoTab = useMemo(() => seoTabsConfig.find((item) => item.key === selectedKey), [selectedKey]);

  const onMenuButtonClick: MenuProps['onClick'] = (e) => {
    const newTab = e.key as SeoTabs;
    setSelectedKey(newTab);
  };

  return (
    <StyledPageWrapper>
      <StyledHeaderWrapper>
        <StyledPageTitle>{t('seo_page_title')}</StyledPageTitle>
        <StyledMenu
          mode="horizontal"
          items={seoTabsConfig}
          defaultSelectedKeys={[selectedKey]}
          selectedKeys={[selectedKey]}
          onClick={onMenuButtonClick}
        />
      </StyledHeaderWrapper>

      {selectedSeoTab!.content}
    </StyledPageWrapper>
  );
};

export default SeoMainContainer;
